import uniqBy from 'lodash/uniqBy'
import { VEHICLE_TIRES, SIZE_NOT_LISTED_OPTION, VEHICLE_ENGINE } from './constants'
import { VEHICLE_MILEAGE, VEHICLE_NICKNAME, LICENCE_NAME, STATE_NAME } from 'constant'
import { isNicknamePersonalized } from 'components/MyGarage2.0/helpers'

const mapToOptions = (colors = []) =>
  colors.map(({ colorDesc: label, colorId: value }) => ({ value, label }))

export const getStatesOptions = (states = []) =>
  states.map(
    ({ stateCode }) => ({ label: stateCode, value: stateCode })
  )

export const integersOnly = (fieldValue, prevValue) => {
  if (!fieldValue) {
    return fieldValue
  }

  // Normalize field value formatted by addCommas helper
  const normalizedValue = fieldValue.replace(/,/g, '')

  if (Number(normalizedValue) >= 0) {
    const newValue = Number.parseInt(normalizedValue, 10)

    // Avoiding weird behavior
    return newValue <= 10 ** 6 ? newValue : 10 ** 6
  }

  return prevValue
}

export const addCommas = (value = '') => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const formatSizes = ({ tireRearSize, tireFrontSize }) =>
  tireRearSize ?
    `Front ${tireFrontSize} | Rear ${tireRearSize}` :
    tireFrontSize

export const createInitialValues = ({
  userVehicleDetails: {
    mileage,
    engineId,
    tireFrontSize,
    tireRearSize,
    vehicleNickname,
    vehicleName,
    lisencePlate,
    state
  } = {}
}) => ({
  [VEHICLE_NICKNAME]: isNicknamePersonalized(vehicleName, vehicleNickname) ? vehicleNickname : '',
  [VEHICLE_MILEAGE]: mileage || '',
  [VEHICLE_ENGINE]: engineId || '',
  [VEHICLE_TIRES]: formatSizes({ tireFrontSize, tireRearSize }),
  [LICENCE_NAME]: lisencePlate || '',
  [STATE_NAME]: state || ''
})

export const prepareVehicleData = ({
  masterVehicle,
  subModelImageName,
  vehicleName,
  engineId: engineConfigId,
  vehicleType,
  engineDesc,
  vehicleColor: colorId,
  mileage,
  vehicleNickname: nickname,
  hasStaggeredFitment,
  userVehicleId,
  userVehicleType: userType,
  tireFrontSize,
  tireRearSize
}) => ({
  ...masterVehicle,
  subModelImageName,
  vehicleName,
  engineConfigId,
  vehicleType,
  engineDesc,
  colorId,
  mileage,
  nickname,
  hasStaggeredFitment,
  userVehicleId,
  userType,
  tireFrontSize,
  tireRearSize
})

export const parseSizes = string => {
  const [tireFrontSize = null, tireRearSize = null] =
    string.match(/[A-Z]*[0-9x]+[/|.][0-9]+[A-Z]*[R/]{1}[0-9.]+[A-Z]*\/*[A-Z]*/g)
  return {
    tireFrontSize,
    tireRearSize,
    hasStaggeredFitment: Boolean(tireRearSize)
  }
}

export const getSubModelImageName = carImage => carImage ?
  carImage.split('/').pop() :
  null

export const getTireSizesOptions = ({ userVehicleDetails, vehicleCompatibleSizes }) => uniqBy(
  [userVehicleDetails, ...vehicleCompatibleSizes]
    .map(size => ({ label: formatSizes(size), value: formatSizes(size) }))
    .concat({ label: SIZE_NOT_LISTED_OPTION, value: SIZE_NOT_LISTED_OPTION }),
  option => option.value
)

export const getColorOptions = (colors = []) => ([
  {
    label: 'Model Colors',
    options: mapToOptions(colors.filter(({ isCustom }) => !isCustom))
  },
  {
    label: 'Custom Colors',
    options: mapToOptions(colors.filter(({ isCustom }) => isCustom))
  }
])

export const getEngineOptions = (engines = []) =>
  engines.map(({ engineDesc, engineId }) => ({ label: engineDesc, value: String(engineId) }))


export const combineColors = (modelColors, customColors) =>
  modelColors.map(({ ...props }) => ({ ...props, isCustom: false })).concat(
    customColors.map(({ ...props }) => ({ ...props, isCustom: true })))
